import { useAuth } from '../context/AuthContext';
import { User, Mail, Trophy, Flame, Target, BookOpen } from 'lucide-react';

const ProfilePage = () => {
  const { user } = useAuth();

  if (!user) return null;

  return (
    <div className="space-y-8">
      <div>
        <h1 className="text-4xl font-heading font-bold text-slate-900 mb-2">Profil</h1>
        <p className="text-lg text-slate-600">Deine Account-Informationen</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-3 gap-6">
        <div className="lg:col-span-2 bg-white rounded-3xl p-8 border border-slate-100 shadow-sm">
          <h2 className="text-2xl font-heading font-bold text-slate-900 mb-6">Persönliche Daten</h2>
          <div className="space-y-6">
            <div className="flex items-center gap-4 p-4 bg-slate-50 rounded-2xl">
              <div className="p-3 bg-primary-100 rounded-xl">
                <User className="text-primary-600" size={24} />
              </div>
              <div className="flex-1">
                <p className="text-sm text-slate-600">Name</p>
                <p className="text-lg font-bold text-slate-900">{user.name}</p>
              </div>
            </div>
            <div className="flex items-center gap-4 p-4 bg-slate-50 rounded-2xl">
              <div className="p-3 bg-teal-100 rounded-xl">
                <Mail className="text-teal-600" size={24} />
              </div>
              <div className="flex-1">
                <p className="text-sm text-slate-600">Email</p>
                <p className="text-lg font-bold text-slate-900">{user.email}</p>
              </div>
            </div>
            <div className="flex items-center gap-4 p-4 bg-slate-50 rounded-2xl">
              <div className="p-3 bg-indigo-100 rounded-xl">
                <BookOpen className="text-indigo-600" size={24} />
              </div>
              <div className="flex-1">
                <p className="text-sm text-slate-600">Mitglied seit</p>
                <p className="text-lg font-bold text-slate-900">
                  {new Date(user.created_at).toLocaleDateString('de-DE', { day: '2-digit', month: 'long', year: 'numeric' })}
                </p>
              </div>
            </div>
          </div>
        </div>

        <div className="space-y-6">
          <div className="bg-gradient-to-br from-purple-500 to-indigo-600 rounded-3xl p-6 text-white shadow-lg">
            <div className="flex items-center gap-3 mb-4">
              <div className="p-2 bg-white/20 rounded-xl backdrop-blur-sm">
                <Trophy size={24} />
              </div>
              <div>
                <p className="text-sm opacity-90">Level</p>
                <p className="text-3xl font-heading font-bold">{user.level || 1}</p>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-orange-400 to-red-500 rounded-3xl p-6 text-white shadow-lg">
            <div className="flex items-center gap-3 mb-4">
              <div className="p-2 bg-white/20 rounded-xl backdrop-blur-sm">
                <Flame size={24} />
              </div>
              <div>
                <p className="text-sm opacity-90">Lernstreak</p>
                <p className="text-3xl font-heading font-bold">{user.streak || 0} Tage</p>
              </div>
            </div>
          </div>

          <div className="bg-gradient-to-br from-teal-400 to-emerald-500 rounded-3xl p-6 text-white shadow-lg">
            <div className="flex items-center gap-3 mb-4">
              <div className="p-2 bg-white/20 rounded-xl backdrop-blur-sm">
                <Target size={24} />
              </div>
              <div>
                <p className="text-sm opacity-90">Punkte</p>
                <p className="text-3xl font-heading font-bold">{user.points || 0}</p>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="bg-white rounded-3xl p-8 border border-slate-100 shadow-sm">
        <h2 className="text-2xl font-heading font-bold text-slate-900 mb-4">Über FocusFlow</h2>
        <p className="text-slate-600 leading-relaxed">
          FocusFlow hilft dir, organisiert zu bleiben und deine Lernziele zu erreichen. 
          Nutze KI-gestützte Lernpläne, tracke deine Fortschritte und bleibe motiviert 
          mit unserem Belohnungssystem. Viel Erfolg beim Lernen! 🎓
        </p>
      </div>
    </div>
  );
};

export default ProfilePage;
